
    import './styles.scoped.css';
    export default {
  "body-cell": "awsui_body-cell_c6tup_6wa2x_93",
  "body-cell-wrap": "awsui_body-cell-wrap_c6tup_6wa2x_103",
  "is-visual-refresh": "awsui_is-visual-refresh_c6tup_6wa2x_115",
  "has-striped-rows": "awsui_has-striped-rows_c6tup_6wa2x_127",
  "body-cell-edit-active": "awsui_body-cell-edit-active_c6tup_6wa2x_130",
  "body-cell-editable": "awsui_body-cell-editable_c6tup_6wa2x_130",
  "has-striped-rows-sticky-cell-pad-left": "awsui_has-striped-rows-sticky-cell-pad-left_c6tup_6wa2x_136",
  "has-selection": "awsui_has-selection_c6tup_6wa2x_139",
  "body-cell-first-row": "awsui_body-cell-first-row_c6tup_6wa2x_145",
  "body-cell-last-row": "awsui_body-cell-last-row_c6tup_6wa2x_148",
  "body-cell-selected": "awsui_body-cell-selected_c6tup_6wa2x_148",
  "has-footer": "awsui_has-footer_c6tup_6wa2x_148",
  "body-cell-shaded": "awsui_body-cell-shaded_c6tup_6wa2x_158",
  "sticky-cell": "awsui_sticky-cell_c6tup_6wa2x_178",
  "sticky-cell-pad-left": "awsui_sticky-cell-pad-left_c6tup_6wa2x_186",
  "sticky-cell-last-right": "awsui_sticky-cell-last-right_c6tup_6wa2x_203",
  "sticky-cell-last-left": "awsui_sticky-cell-last-left_c6tup_6wa2x_207",
  "body-cell-next-selected": "awsui_body-cell-next-selected_c6tup_6wa2x_230",
  "body-cell-prev-selected": "awsui_body-cell-prev-selected_c6tup_6wa2x_234",
  "body-cell-editor": "awsui_body-cell-editor_c6tup_6wa2x_258",
  "body-cell-success": "awsui_body-cell-success_c6tup_6wa2x_263",
  "body-cell-success-form": "awsui_body-cell-success-form_c6tup_6wa2x_288",
  "body-cell-editor-form": "awsui_body-cell-editor-form_c6tup_6wa2x_288",
  "body-cell-success-row": "awsui_body-cell-success-row_c6tup_6wa2x_297",
  "body-cell-editor-row": "awsui_body-cell-editor-row_c6tup_6wa2x_297",
  "body-cell-success-controls": "awsui_body-cell-success-controls_c6tup_6wa2x_307",
  "body-cell-editor-controls": "awsui_body-cell-editor-controls_c6tup_6wa2x_307",
  "body-cell-has-success": "awsui_body-cell-has-success_c6tup_6wa2x_331"
};
  